module.exports = __webpack_public_path__ + "img/logo.f0e1aa8d.svg";